require('./_core1');
require('./_core2');


// WEBPACK FOOTER //
// ./resources/assets/js/app.js